// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"0453d57a","986":"4f359805"}[chunkId] + ".css";
};